import { render, staticRenderFns } from "./contentAdd.vue?vue&type=template&id=33a4f530&scoped=true&"
import script from "./contentAdd.vue?vue&type=script&lang=ts&"
export * from "./contentAdd.vue?vue&type=script&lang=ts&"
import style0 from "./contentAdd.vue?vue&type=style&index=0&id=33a4f530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4f530",
  null
  
)

export default component.exports